<template>
  <span style="text-align:left">
    <template v-if="modo=='new'||modo=='edit'||modo=='flow'">
      <v-input
        :value="(value)"
        required
        :rules="crud.evalrules(campo)"
        :hint="T(campo.cmp_dica)"
        persistent-hint
      >
        <el-slider
          style="width: 100%;"
          v-bind:value="preLoad(value)"
          v-on:input="(event)=>$emit('input', preUpdate(event))"
          :show-input="getComponentParam('input')=='true'?true:false"
          :min="getComponentParam('min')!==null?getComponentParam('min')*1:0"
          :max="getComponentParam('max')!==null?getComponentParam('max')*1:100"
          :step="getComponentParam('step')||1"
          :show-stops="getComponentParam('stops')=='true'?true:false"
          :range="getComponentParam('range')=='true'?true:false"
          :show-input-controls="getComponentParam('input-controls')=='false'?false:true"
        ></el-slider>
        <v-chip v-if="getComponentParam('chip')=='false'?false:true">{{value}}</v-chip>
      </v-input>
    </template>

    <template v-if="modo=='list' || modo=='view' || modo=='viewmode'">
      <span :class="{'text-xs-center':modo=='list'}">{{displayvalue}}</span>
    </template>

    <template v-if="modo=='filtro'">
      <v-input hide-details :value="(value)" :hint="T(campo.cmp_dica)" persistent-hint>
        <v-text-field
          v-if="getComponentParam('range')=='true'?true:false"
          height="20"
          class="ma-0 pa-1"
          hide-details
          v-bind:value="preLoadFiltro(value)"
          v-on:input="(event)=>$emit('input', preUpdateFiltro(event))"
          :mask="getComponentParam('mask')"
          background-color="#fcfcfc"
        ></v-text-field>

        <template v-else>
          <el-slider
            style="width: 100%;"
            v-bind:value="preLoad(value)"
            v-on:input="(event)=>$emit('input', preUpdate(event))"
            :show-input="getComponentParam('input')=='true'?true:false"
            :min="getComponentParam('min')||0"
            :max="getComponentParam('max')||100"
            :step="getComponentParam('step')||1"
            :show-stops="getComponentParam('stops')=='true'?true:false"
            :range="getComponentParam('range')=='true'?true:false"
            :show-input-controls="getComponentParam('input-controls')=='false'?false:true"
          ></el-slider>
          <v-chip v-if="getComponentParam('chip')=='false'?false:true">{{value}}</v-chip>
        </template>
      </v-input>
    </template>
  </span>
</template>
    

<script>
try{
  var _baseComponent = require("@/lib/componente/_base.vue").default;
}catch(err){
  var _baseComponent = require("@/framework/lib/componente/_base.vue").default;
}

export default {
  extends: _baseComponent,

  data() {
    return {};
  },
  methods: {
    preUpdate(myval) {
      if (this.getComponentParam("range") == "true") {
        if (myval == null)
          return (
            (this.getComponentParam("min") || "0") +
            "," +
            (this.getComponentParam("min") || "0")
          );
        return myval.join(",");
      }
      return myval == 0 ? "" : myval;
    },
    preLoad(myval) {
      if (this.getComponentParam("range") == "true") {
        if (myval == null)
          return [
            (this.getComponentParam("min") || 0) * 1,
            (this.getComponentParam("min") || 0) * 1,
          ];
        return myval.split(",");
      }
      return myval * 1;
    },
  },
};
</script>

<style scoped>
.decimalnumber input {
  font-size: 24px !important;
  height: 42px;
  line-height: 42px;
  background-color: red;
  margin-top: 13px;
  border-bottom: solid #ccc 1px;
  background-color: #fcfcfc;
}
.decimalnumberfiltro input {
  font-size: 18px !important;
  height: 36px;
  line-height: 36px;
  background-color: red;
  border-bottom: solid #ccc 1px;
  background-color: #fcfcfc;
  margin: 2px;
}
</style>

    